import React from 'react';
const tomes = [{
  number: '01',
  title: 'La Anatomía del Estancamiento',
  desc: 'Mapa de resistencias y tipos de estancamiento'
}, {
  number: '02',
  title: 'El Protocolo de Giro Inmediato',
  desc: 'Preguntas disruptivas, reencuadre y guiones de intervención'
}, {
  number: '03',
  title: 'El Blindaje Emocional del Terapeuta',
  desc: 'Burnout, síndrome del impostor y sostenimiento profesional'
}, {
  number: '04',
  title: 'Abordaje de Casos Límite',
  desc: 'Crisis, ideación, desborde y protocolo de seguridad'
}, {
  number: '05',
  title: 'La Psicología del Compromiso',
  desc: 'Ghosting, abandono y retención sin violar el encuadre'
}, {
  number: '06',
  title: 'El Sistema de Alta Complejidad',
  desc: 'Checklist maestro, derivación y escalamiento de la práctica'
}];
const includes = ['Guiones de intervención listos para usar', 'Protocolos de crisis y contención inmediata', 'Herramientas de blindaje emocional', 'Estrategias de retención y anti-ghosting', 'Checklists clínicos por tomo', 'Marco clínico con fundamento real'];
export function WhatYouGet() {
  return <section className="w-full px-4 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(245,243,255) 0%, rgb(245,243,255) 15%, rgb(245,243,255) 85%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-367">
      <div className="mx-auto max-w-3xl" data-id="element-368">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-369">
          Lo que <span className="text-violet-700" data-id="element-370">recibís</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-371">
          6 tomos · +360 páginas · Todo listo para implementar desde hoy
        </p>

        {/* Tomos */}
        <div className="bg-white border border-violet-500/20 rounded-xl overflow-hidden shadow-sm mb-6" data-id="element-372">
          <div className="bg-violet-700 px-5 py-3" data-id="element-373">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-374">
              🧠 LOS 6 TOMOS — El Método del Caso Difícil
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-375">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-3" data-id="element-376">
                <span className="shrink-0 text-lg font-black text-violet-700/30 w-8 text-center" data-id="element-377">
                  {tome.number}
                </span>
                <div className="flex-1 min-w-0" data-id="element-378">
                  <span className="block text-sm font-black text-gray-900" data-id="element-379">
                    {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-380">
                    {tome.desc}
                  </span>
                </div>
                <span className="shrink-0 text-[10px] font-bold text-violet-700 bg-violet-500/5 border border-violet-500/20 rounded-full px-2 py-0.5" data-id="element-381">
                  60 pág.
                </span>
              </div>)}
          </div>
        </div>

        {/* Cada tomo incluye */}
        <div className="bg-white border border-violet-500/20 rounded-xl overflow-hidden shadow-sm" data-id="element-382">
          <div className="bg-violet-500/5 border-b border-violet-500/20 px-5 py-3" data-id="element-383">
            <h3 className="text-sm font-black text-violet-700 m-0" data-id="element-384">
              Cada tomo incluye:
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 divide-y sm:divide-y-0 divide-gray-100" data-id="element-385">
            {includes.map((item, i) => <div key={item} className={`flex items-start gap-3 px-5 py-3 ${i % 2 === 0 ? 'sm:border-r border-gray-100' : ''}`} data-id="element-386">
                <span className="shrink-0 text-violet-700 font-bold text-sm mt-0.5" data-id="element-387">
                  ✅
                </span>
                <span className="text-xs text-gray-700 leading-5" data-id="element-388">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}